<template>
  <v-text-field
    v-model="myValue"
    type="number"
    :dense="dense"
    :outlined="outlined"
    :label="myLabel"
    :placeholder="placeholder"
    :disabled="disabled"
    :prefix="prefix"
    :suffix="suffix"
    hide-details
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :color="color"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    currency: {
      type: String,
      default: null,
    },
    showCurrency: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
      default: null,
    },
    prependInnerIcon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    prefix: null,
    suffix: null,
    myValue: null,
  }),
  computed: {
    myLabel() {
      if (this.currency && this.showCurrency) return this.label + ` (${this.currency})`
      return this.label
    },
  },
  watch: {
    value: {
      handler() {
        this.myValue = this.value
      },
      immediate: true,
    },
    myValue() {
      if (isNaN(this.myValue)) this.myValue = 0
      else if (this.myValue < 0 && !this.allowNegative) this.myValue = 0

      this.$emit('input', this.myValue)
    },
    currency: {
      handler() {
        this.prefix = null
        this.suffix = null
        if (this.currency === 'EUR') this.suffix = '€'
        else if (this.currency === 'USD') this.prefix = '$'
        else this.suffix = this.currency
      },
      immediate: true,
    },
  },
}
</script>
